import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { removeDiscount } from "actions/account/subscription";
import useToggle from "hooks/useToggle";
import { useGlobalContext } from "context/global";
import ConfirmDialog from "components/confirm-dialog";

const DiscountCodes = () => {
	const {
		translation,
		cartSettings: { subscription },
		subscriptionRules: { commitmentBasedDiscounts, timeLimitedDiscounts },
	} = useGlobalContext();
	const { discounts } = useSelector(state => state.account.subscription);

	const [confirmRemove, toggleRemove] = useToggle();
	const dispatch = useDispatch();

	const removeDiscountById = async (discountShopifyId) => {
		const response = await dispatch(removeDiscount(discountShopifyId));
		if (response.success) {
			toast.warning(translation.subscription.manage_coupon.has_been_removed);
		} else {
			toast.error(response.message);
		}
	};

	const filteredDiscounts = discounts.filter(d =>
		d.title && !d.title.includes("Amount_Off") && d.title !== "200DPDFUPCW1-T2NDK5SGZ18Z"
	);

	const nonRemovableDiscounts = [].concat(
		subscription.discountCode || [],
		commitmentBasedDiscounts?.map(cb => cb?.title) || [],
		timeLimitedDiscounts || []
	);

	if (!filteredDiscounts.length) return null;

	return (
		<div className="flex gap-x-5 gap-y-1.5 mt-2 flex-wrap justify-center">
			{filteredDiscounts.map(({ shopifyId, title }) => (
				<React.Fragment key={shopifyId}>
					<ConfirmDialog
						title={translation.subscription.manage_coupon.remove_this_coupon}
						isOpen={confirmRemove}
						confirmText="Delete"
						setIsOpen={toggleRemove}
						callback={() => removeDiscountById(shopifyId)}
						className="max-w-[350px]"
					/>
					<div className="sub-discount-codes">
						<span className="text-small">{title}</span>
						{!nonRemovableDiscounts.includes(title) && (
							<button type="button" onClick={toggleRemove} className="text-sm">X</button>
						)}
					</div>
				</React.Fragment>
			))}
		</div>
	);
};

export default DiscountCodes;